module.exports = __webpack_public_path__ + "pc/img/img5.c302b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head/img5.png
// module id = el/7
// module chunks = 3